/// Identidade visual BHS 2026.
/// Espelha as variáveis SCSS em EstruturaAntiga/stylesheets/abstracts/_variables.scss —
/// o SCSS não é importável por JS, então os valores existem nos dois lugares.
export const BHS_VERDE_CLARO = '#1ce766';
export const BHS_VERDE = '#00ac22';
export const BHS_PRETO = '#1d252c';

/// Cores de estado. Ficam fora da paleta da marca de propósito: o verde institucional
/// significa "ação" e "concluído", e misturá-lo com sucesso/erro torna os dois ilegíveis
/// quando aparecem lado a lado (ex.: etapa ativa vs. etapa concluída num indicador).
export const ESTADO_SUCESSO = '#34be46';
export const ESTADO_ERRO = '#be3434';
export const ESTADO_NEUTRO = '#b9c3d4';
